import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { LoadingButton } from "@mui/lab";
import { Grid, TextField } from "@mui/material";
import { FormikProps, useFormik } from "formik";
import React, { useEffect } from "react";
import * as yup from "yup";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useApiFeedback } from "../../../../app/useApiFeedback";
import MessageResponse from "../../../../common/feedback/messageResponse";
import { addDeclineReasonDto } from "../../models";
import { selectAdmin } from "../../adminSlice";
import { addDeclineReasonThunk, EditDeclineReasonThunk } from "../../thunks";

interface Props {
  formLoad: addDeclineReasonDto | null;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function DeclineReasonForm({ formLoad, setOpen }: Props) {
  const dispatch = useAppDispatch();
  const { feedback, handleApiResponse } = useApiFeedback();

  const validationSchema = yup.object({
    description: yup
      .string()
      .required("Please enter description")
      .min(10, "Please type in at least 10 characters"),
    reason: yup
      .string()
      .required("Please enter decline reason")
      .min(10, "Please type in at least 10 characters"),
  });

  const selectAdminAction = useAppSelector(selectAdmin);
  const loadFormFromProps = () => {
    if (formLoad) {
      formik.setFieldValue("reason", formLoad.reason);
      formik.setFieldValue("description", formLoad.description);
      formik.setFieldValue("id", formLoad.id);
    }
  };

  useEffect(() => {
    loadFormFromProps();
  }, [formLoad]);

  const formik: FormikProps<addDeclineReasonDto> =
    useFormik<addDeclineReasonDto>({
      initialValues: {
        description: "",
        reason: "",
        id: 0,
      },
      validationSchema: validationSchema,
      onSubmit: (values: addDeclineReasonDto) => {
        if (values.id === 0) {
          dispatch(addDeclineReasonThunk(values)).then((resp: any) => {
            handleApiResponse(resp, true);
          });
        }

        if (values.id > 0) {
          dispatch(EditDeclineReasonThunk(values)).then((resp: any) => {
            handleApiResponse(resp, true);
          });
        }
        setOpen(false);
        formik.resetForm();
      },
    });

  return (
    <>
      <MessageResponse feedback={feedback} />

      <Grid container spacing={2} mb={4}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="reason"
            name="reason"
            label="Enter Reason Identifier"
            value={formik.values.reason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            type="text"
            error={formik.touched.reason && Boolean(formik.errors.reason)}
            helperText={
              formik.touched.reason && (formik.errors.reason as React.ReactNode)
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="description"
            name="description"
            label="Enter Description (This will be used in the email sent out)"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            type="text"
            error={
              formik.touched.description && Boolean(formik.errors.description)
            }
            helperText={
              formik.touched.description &&
              (formik.errors.description as React.ReactNode)
            }
          />
        </Grid>
        <Grid item xs={12}>
          <LoadingButton
            sx={{ float: "left", marginBottom: 1.5 }}
            color="primary"
            variant="contained"
            startIcon={<SaveOutlinedIcon />}
            onClick={() => {
              formik.submitForm();
            }}
            disabled={!formik.dirty}
            loading={
              selectAdminAction.adminApplicantDeclineState.status === "loading"
            }
            loadingPosition="start"
          >
            Save Decline Reason
          </LoadingButton>
        </Grid>
      </Grid>
    </>
  );
}
